import { VALIDATION_MESSAGE } from '../ValidationMessage';
import { createDateSchema } from './CustomValidation/DateExtendedSchema';
import yup from './CustomValidation/yup-extended';
import { DateSchemaType, ExtendedDateSchemaType } from './ValidationTypes';

export const SeniorSnapshotValidationSchema = yup.object().shape({
  studentIdentifierState: yup.string(),
  studentFirstName: yup.string(),
  studentLastOrSurname: yup.string(),
  birthDate: yup.string(),
  gender: yup.string(),
  ethnicity: yup.string(),
  race: yup.string(),
  algebraTransferDate: (createDateSchema() as ExtendedDateSchemaType)
    .when('algebraReason', {
      is: (algebraReason: string | undefined) =>
        algebraReason !== undefined && algebraReason !== '',
      then: (schema: DateSchemaType) =>
        (schema as ExtendedDateSchemaType).required(
          VALIDATION_MESSAGE.REQUIRED
        ),
      otherwise: (schema: DateSchemaType) =>
        (schema as ExtendedDateSchemaType).notRequired(),
    })
    .max(
      new Date(),
      VALIDATION_MESSAGE.AFTER_OR_EQUAL_TO_DATE(
        `${new Date().toISOString().split('T')[0]}`
      )
    ),
  englishTransferDate: (createDateSchema() as ExtendedDateSchemaType)
    .when('englishReason', {
      is: (englishReason: string | undefined) =>
        englishReason !== undefined && englishReason !== '',
      then: (schema: DateSchemaType) =>
        (schema as ExtendedDateSchemaType).required(
          VALIDATION_MESSAGE.REQUIRED
        ),
      otherwise: (schema: DateSchemaType) =>
        (schema as ExtendedDateSchemaType).notRequired(),
    })
    .max(
      new Date(),
      VALIDATION_MESSAGE.AFTER_OR_EQUAL_TO_DATE(
        `${new Date().toISOString().split('T')[0]}`
      )
    ),
  biologyTransferDate: (createDateSchema() as ExtendedDateSchemaType)
    .when('biologyReason', {
      is: (biologyReason: string | undefined) =>
        biologyReason !== undefined && biologyReason !== '',
      then: (schema: DateSchemaType) =>
        (schema as ExtendedDateSchemaType).required(
          VALIDATION_MESSAGE.REQUIRED
        ),
      otherwise: (schema: DateSchemaType) =>
        (schema as ExtendedDateSchemaType).notRequired(),
    })
    .max(
      new Date(),
      VALIDATION_MESSAGE.AFTER_OR_EQUAL_TO_DATE(
        `${new Date().toISOString().split('T')[0]}`
      )
    ),
  historyTransferDate: (createDateSchema() as ExtendedDateSchemaType)
    .when('historyReason', {
      is: (historyReason: string | undefined) =>
        historyReason !== undefined && historyReason !== '',
      then: (schema: DateSchemaType) =>
        (schema as ExtendedDateSchemaType).required(
          VALIDATION_MESSAGE.REQUIRED
        ),
      otherwise: (schema: DateSchemaType) =>
        (schema as ExtendedDateSchemaType).notRequired(),
    })
    .max(
      new Date(),
      VALIDATION_MESSAGE.AFTER_OR_EQUAL_TO_DATE(
        `${new Date().toISOString().split('T')[0]}`
      )
    ),
  algebraTransferredfromSchoolName: yup
    .string()
    .max(300, VALIDATION_MESSAGE.AT_MOST_CHARS(300))
    .matches(/^[a-zA-Z\s]+$/, VALIDATION_MESSAGE.MUST_BE_JUST_CHARACTERS),
  englishTransferredfromSchoolName: yup
    .string()
    .max(300, VALIDATION_MESSAGE.AT_MOST_CHARS(300))
    .matches(/^[a-zA-Z\s]+$/, VALIDATION_MESSAGE.MUST_BE_JUST_CHARACTERS),
  biologyTransferredfromSchoolName: yup
    .string()
    .max(300, VALIDATION_MESSAGE.AT_MOST_CHARS(300))
    .matches(/^[a-zA-Z\s]+$/, VALIDATION_MESSAGE.MUST_BE_JUST_CHARACTERS),
  historyNameofSchoolStudentTransferredfrom: yup
    .string()
    .max(300, VALIDATION_MESSAGE.AT_MOST_CHARS(300))
    .matches(/^[a-zA-Z\s]+$/, VALIDATION_MESSAGE.MUST_BE_JUST_CHARACTERS),
  documentsUploadedToSharePoint: yup
    .boolean()
    .oneOf([true], VALIDATION_MESSAGE.REQUIRED),
  denialReason: yup
    .string()
    .when('reviewStatus', {
      is: (reviewStatus: string | undefined) => reviewStatus === 'Denied',
      then: yup.string().required(VALIDATION_MESSAGE.REQUIRED),
      otherwise: yup.string().notRequired(),
    })
    .max(1000, VALIDATION_MESSAGE.AT_MOST_CHARS(1000)),
});
